import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import type { ThemeObject } from "@circle-react/types/Theme";
import { useMemo } from "react";

const emptyColor = {
  light: "",
  dark: "",
};

export const useCommunityTheme = (fallback: ThemeObject): ThemeObject => {
  const { currentCommunity, currentCommunitySettings, isLoading } =
    usePunditUserContext();
  const themeSettings = currentCommunitySettings?.theme_settings;
  const prefs = currentCommunity?.prefs;

  return useMemo(() => {
    if (isLoading || !themeSettings) return fallback;

    return {
      ...fallback,
      current_theme: themeSettings.current_theme,
      default_appearance: themeSettings.default_appearance,
      is_custom: themeSettings.current_theme === "custom",
      custom_colors: themeSettings.custom_colors,
      brand_color: prefs?.brand_color ?? fallback.brand_color ?? emptyColor,
      brand_text_color:
        prefs?.brand_text_color ?? fallback.brand_text_color ?? emptyColor,
    };
  }, [fallback, isLoading, prefs, themeSettings]);
};
